import { Code, Flex, Spinner, useToast } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { jsonToYaml } from "../../../fix-search/API"
import { ErrorToast } from "../Notifications/NotificationToast"

export const YamlView = ({
    object,
    notify,
    closeView,
    codeStyle
}) => {

    const [yamlValue, setYamlValue] = useState(null) 

    const toast = useToast()

    useEffect(() => {
        const json = JSON.stringify(object, null, 2)
        if (!object || !json) {
            setYamlValue('<Value is not specified>')
            return
        }

        console.log(json, !!json)

        jsonToYaml(json)
            .then((response) => {
                setYamlValue(response.data)
            })
            .catch(e => {
                toast({
                    position: 'top',
                    duration: null,
                    isClosable: true,
                    render: ({onClose}) => (
                        <ErrorToast
                            description={'Failed to build YAML config'}
                            onClose={onClose}
                        >
                            <Code width='480px' padding={3} borderRadius={5}>
                                {e?.response?.data}
                            </Code>
                        </ErrorToast>
                    )
                })
                console.log(e)
                console.log(e?.response)
                console.log(e?.toJSON())
                notify({
                    level: 'ERROR',
                    message: `Failed to build YAML config: ${e?.message}`,
                    stackTrace: e?.stack,
                    responseData: e?.response?.data
                })
                closeView()
            })
    }, [object])
    
    return (
        <>
            {yamlValue === null &&
                <Flex width='630px' minWidth='630px' justifyContent='center'>
                    <Spinner alignSelf='center'/>
                </Flex>
            }
            {yamlValue !== null && 
                <Code
                    minHeight='40px'
                    borderRadius={5}
                    padding={3}
                    whiteSpace='pre'
                    overflowX='auto'
                    minWidth='630px'
                    style={codeStyle}
                >
                    {yamlValue}
                </Code>
            }
        </>
    )
}